<script setup>
import { computed } from 'vue'
import { useODataSource } from '@/composables/data-grid'
import { useRegistryStore } from '@/stores/registry.store'

import GridDropDownBox from '@/components/shared/GridDropDownBox.vue'

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  supplier: {
    type: Number,
    default: null,
  },
  showClearButton: {
    type: Boolean,
    default: false,
  },
})

const registryStore = useRegistryStore()

const defaultDataSource = useODataSource(registryStore.api.getAbsoluteUrl() + registryStore.api.supplierDivisionsUrl, {
  searchExpr: ['code']
})

const dropDownDisplayExpr = (divisionName) => {
  return (obj) => {
    if (!obj) return ''
    if (typeof obj === 'string') return obj

    if (divisionName) return `${divisionName}`

    return `${obj.code} - ${obj.name}`
  }
}

const computedDataSource = computed(() => {
  const ds = defaultDataSource
  if (props.supplier) {
    ds.filter(['supplier', '=', props.supplier])
  }
  return ds
})

const displayExpr = computed(() => {
  const divisionName = props?.data?.data?.division_name
  return dropDownDisplayExpr(divisionName)
})
</script>

<template>
  <grid-drop-down-box
    :value="props.data.value"
    :disabled="props.disabled"
    :data-source="computedDataSource"
    :show-clear-button="props.showClearButton"
    :columns="[
      { dataField: 'code', caption: $t('common.code') },
      { dataField: 'name', caption: $t('common.name') },
      { dataField: 'vat_number', caption: $t('common.vatNumber') },
    ]"
    :drop-down-display-expr="displayExpr"
    :drop-down-options="{ width: 700 }"
    @value-changed="(e) => props.data.setValue(e)"
  />
</template>
